import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { format, parseISO } from "date-fns";

const InvoiceStatementImage = React.memo(
   ({ alt, docId, docPartId, supName, custName, invoiceCount, invoiceMatchCount, hasFollowUps, statementState, reviewSeverity, supplier_type, supplier_month, active_section, onClick, onDoubleClick, isSelected, StatusIcon, disabled, urgencyBucket, dueDate }) => {
      const [isHovered, setIsHovered] = useState(false);
      const boxShadow = "8px 4px 8px rgba(0, 0, 0, 0.25)";
      const hoverBorder = "1px solid rgba(0, 0, 0, 0.175)";

      // Terms-urgency ring: a persistent colored frame (not hover-only) so urgent
      // statements are scannable at a glance. Collapsed to red (overdue) / amber
      // (due within 14 days); everything else stays white. Suppressed on Setup
      // (no terms) and Reconciled (done) tabs. Selection (blue) takes precedence.
      const URGENCY_RING = { OVERDUE: "#dc3545", DUE_THIS_WEEK: "#f59e0b", DUE_2_WEEKS: "#f59e0b" };
      const ringEnabled = !disabled && active_section !== "setup" && active_section !== "reconciled";
      const ringColor = ringEnabled ? URGENCY_RING[urgencyBucket] : undefined;
      let cardBorder;
      if (isSelected) cardBorder = undefined; // bootstrap border-primary class handles it
      else if (ringColor) cardBorder = `2px solid ${ringColor}`;
      else if (isHovered) cardBorder = hoverBorder;
      else cardBorder = "none";
      const cardShadow = isHovered
         ? ringColor
            ? `${boxShadow}, 0 0 0 3px ${ringColor}40`
            : boxShadow
         : "none";
      const urgencyTitle = ringColor && dueDate ? `Due ${dueDate}` : undefined;

      return (
         <div
            className="icon-item text-start me-3 position-relative "
            style={{ height: "250px", opacity: disabled ? 0.5 : 1 }}>
            <Card
               title={urgencyTitle}
               className={`p-2 ${isSelected ? "border border-primary shadow-sm" : ""} d-flex align-items-center justify-content-center`}
               style={{ width: "180px", borderRadius: "10px", overflow: "hidden", transition: "box-shadow 0.3s ease-in-out", boxShadow: cardShadow, border: cardBorder }}>
               <Card.Body className="p-2 text-center">
                  <div
                     className="pt-1"
                     onMouseEnter={() => setIsHovered(true)}
                     onMouseLeave={() => setIsHovered(false)}
                     onClick={disabled ? undefined : onClick}>
                     <div
                        className="mt-auto text-truncate text-start"
                        style={{ minHeight: "20px", maxWidth: "160px", overflow: "hidden", whiteSpace: "nowrap", position: "relative", top: "-13px", left: "0" }}>
                        {active_section === "location" && supplier_month ? format(parseISO(supplier_month), "MMM yyyy") : supplier_type}
                     </div>
                     <div>
                        <img
                           key={docId}
                           src={`https://storage.googleapis.com/0b4be1ac-452a-4db9-a8cc-a38082af5a60/${docId}.png`}
                           alt={alt}
                           className="img-fluid"
                           style={{
                              height: "170px",
                              cursor: disabled ? "not-allowed" : "pointer",
                              borderRight: "1px solid lightgrey",
                              borderBottom: "1px solid lightgrey",
                              position: "relative",
                              top: "0px",
                              left: "0px",
                              zIndex: 1,
                           }}
                           onDoubleClick={disabled ? undefined : onDoubleClick}
                           loading="lazy"
                        />
                     </div>
                     <div
                        className="position-absolute "
                        style={{
                           top: "30px",
                           left: "15px",
                           zIndex: 1,
                        }}>
                        <StatusIcon
                              statementState={statementState}
                              reviewSeverity={reviewSeverity}
                              invoiceCount={invoiceCount}
                              matchCount={invoiceMatchCount}
                              hasFollowUps={hasFollowUps}
                        />
                     </div>
                     <div
                        className="mt-2 text-start text-truncate"
                        style={{ maxWidth: "160px", overflow: "hidden", whiteSpace: "nowrap" }}>
                        {supName}
                     </div>
                  </div>
               </Card.Body>
            </Card>
         </div>
      );
   },
   (prevProps, nextProps) =>
      prevProps.isSelected === nextProps.isSelected &&
      prevProps.docId === nextProps.docId &&
      prevProps.disabled === nextProps.disabled &&
      prevProps.invoiceCount === nextProps.invoiceCount &&
      prevProps.invoiceMatchCount === nextProps.invoiceMatchCount &&
      prevProps.statementState === nextProps.statementState &&
      prevProps.hasFollowUps === nextProps.hasFollowUps &&
      prevProps.reviewSeverity === nextProps.reviewSeverity &&
      prevProps.urgencyBucket === nextProps.urgencyBucket &&
      prevProps.dueDate === nextProps.dueDate
);

export default InvoiceStatementImage;
